export default __webpack_public_path__ + "de5b61b7b1060364f8dd64c5b6b90bb6.jpg";